import { render } from "./Category.vue?vue&type=template&id=304f7422&scoped=true&ts=true"
import script from "./Category.vue?vue&type=script&lang=ts"
export * from "./Category.vue?vue&type=script&lang=ts"

import "./Category.vue?vue&type=style&index=0&id=304f7422&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-304f7422"]])

export default __exports__